export default {
	security: {
		securityBind: "Security Bind",
		securitySettings: "Security Settings",
		level: "Medium",
		confirm: "Confirm",
		submitting: "Submitting...",
		add: "Add",
		change: "Change",
		success: "Updated successfully",
		select: "Select",

		birthday: "Contact Birthday",
		birthdayDesc: "Bind your birthday to improve your account security.",
		month: "Month",
		day: "Day",
		year: "Year",
		birthdayRequired: "Birthday is required.",
		invalidBirthday: "Invalid birthday.",
		invalidMonth: "Invalid month.",
		invalidDay: "Invalid day.",
		invalidYear: "Invalid year.",
		updateBirthdayFail: "Failed to update birthday",
		birthdayVerify: "Birthday bind verification",
		birthdayVerifyDesc: "Bind your birthday to improve your account security.",

		email: "Contact Email",
		emailDesc: "Email for account security. Only you can bind it.",
		emailRequired: "Email is required.",
		emailInvalid: "Wrong email address.",
		updateEmailFail: "Failed to update email",
		emailVerify: "Email bind verification",
		emailVerifyDesc: "Verify your email address to improve your account security.",

		phone: "Phone Number",
		bindPhone: "Bind Phone Number",
		phoneDesc: "Phone number for account security. Only you can bind it.",
		phoneRequired: "Phone number is required.",
		phoneUsed: "Please use a different phone number.",
		updatePhoneFail: "Failed to update phone number",
		noCode: "No code received?",
		smsHelp: "If you have tried multiple times but still have not received the verification code.",
		smsTips1: "1. Check if the mobile number you entered is correct.",
		smsTips2: "2. Check if your mobile number is out of date.",
		smsTips3: "3. Check if the message is in the SMS bin.",
		smsTips4: "4. The message may be delayed for a few minutes.",
		phoneVerify: "Phone Number bind verification",
		phoneVerifyDesc: "Verify your phone number to improve your account security.",

		setPassword: "Set Password",
		passwordDesc: "Set your sign in password.",
		clickSelectBirthday: "Click to select birthday",
		selectBirthday: "Select Birthday",
		confirm: "Confirm",
		cancel: "Cancel",
		withdrawPassword: "Withdraw Password",
		withdrawpasswordDesc: "Set your sign in withdraw password.",
		set: "Set "
	},

	contactPhone: {
		title: "Phone Number",
		titleMobile: "Change",
		description: "Add your phone number for secure account verification.",
		label: "Contact Phone Number",
		confirm: "Confirm",
		submitting: "Submitting...",
		required: "Phone number is required",
		invalid: "Invalid phone number",
		success: "Phone number updated successfully!",
		updateFailed: "Update failed",
		tryAgain: "Update failed, please try again later",
		verifyTitleMobile: "Phone Verification",
		titleMobile: "Bind Phone",
		changeTitleMobile: "Change Phone",
		securityTip: "Phone for account security. Only you can bind it.",
		placeholder: "Phone Number",
		noCodeReceived: "No code received?",
		codeDescription: "Enter the 6-digit verification code sent to your contact details below:",
		resendIn: "Resend in {countdown} s",
		resend: "Resend",
		submitting: "Submitting...",
		confirm: "Confirm",
		invalidCode: "Please enter a valid 6-digit code",
		required: "Phone number is required",
		invalid: "Please enter a valid phone number",
		success: "Successfully updated",
		updateFailed: "Update failed",
		tryAgain: "Please try again later"
	},

	contactEmail: {
		title: "Change Email",
		titleMobile: "Change",
		description: "Email for account security. Only you can bind it.",
		label: "Contact Email",
		placeholder: "Email",
		confirm: "Confirm",
		submitting: "Submitting...",
		required: "Email cannot be empty",
		invalid: "Please enter a valid email address",
		success: "Email updated successfully!",
		updateFailed: "Update failed",
		tryAgain: "Update failed, please try again later",
		verifyTitleMobile: "Email Verification",
		titleMobile: "Bind Email",
		changeTitleMobile: "Change Email",
		securityTip: "Email for account security. Only you can bind it.",
		noCodeReceived: "No code received?",
		codeDescription: "Enter the 6-digit verification code sent to your contact details below:",
		resendIn: "Resend in {countdown} s",
		resend: "Resend",
		submitting: "Submitting...",
		confirm: "Confirm",
		invalidCode: "Please enter a valid 6-digit code",
		required: "Email is required",
		invalid: "Please enter a valid email address",
		success: "Successfully updated",
		updateFailed: "Update failed",
		tryAgain: "Please try again later"
	},

	accountInfo: {
		profileInfo: "Profile Info",
		contactInfo: "Contact Info",
		privacy: "Privacy",
		contactEmail: "Contact Email",
		contactPhone: "Contact Phone Number",
		addEmailDesc: "Add your email for secure account verification.",
		addPhoneDesc: "Add your phone number for secure account verification.",
		hideUsername: "Hide my username from public lists",
		add: "Add",
		change: "Change",
		idLabel: "ID: ",
		vip: "VIP ",
		player: "PLAYER",
		copied: "Copied!",
		hideSuccess: "Username hidden successfully",
		showSuccess: "Username shown successfully",
		operationFailed: "Operation failed",
		editProfile: "Edit Profile",
		contactInfo: "Contact Info",
		contactEmail: "Contact Email",
		emailTip: "Add a contact email for easier communication. Your personal information will remain protected.",
		change: "Change",
		addEmail: "Add Email",
		contactPhone: "Contact Phone Number",
		phoneTip: "Add your phone number for secure account verification.",
		addPhone: "Add Phone Number",
		birthdayBind: "Birthday bind verification",
		birthdayTip: "Bind your birthday to improve your account security.",
		addBirthday: "Add Birthday",
		personalInfo: "Personal Info",
		personalTip: "Verify your identity to unlock more services. Your data is secure.",
		verifyNow: "Verify Now",
		hideUsernameTip: "When enabled, other users won't be able to see your username in public lists.",
	},

	kyc: {
		title: "Identity Verification",
		verifyIdentity: "Verify Your Identity",
		completeDesc: "Complete identity verification to keep your account secure and unlock all features.",
		failed: "Verification failed. Please try again.",
		reVerify: "Re-verify",
		checkYouOut: "Let's verify your identity",
		prepareDoc: "Prepare your document",
		prepareDocDesc: "Have a valid ID document ready.",
		useSmartphone: "Use a smartphone",
		useSmartphoneDesc: "You will need a smartphone to complete the verification.",
		scanQr: "Scan the QR code",
		scanQrDesc: "Scan the QR code with your phone to continue on mobile.",
		noSmartphone: "No smartphone?",
		completeOnMobile: "Complete on mobile"
	},

	verify: {
		title: "Verification",
		personalVerification: "Personal Verification",
		weak: "Weak",
		level1: "Level 1",
		personalInfo: "Personal Information",
		personalInfoDesc: "Complete your personal information to improve your account security.",
		verifyNow: "Verify Now",
		level2: "Level 2",
		kycVerification: "KYC Verification",
		kycDesc: "Complete KYC verification to unlock higher limits and full access.",
		docTip: "Please make sure your documents are clear and valid before submitting."
	},

	personalInfo: {
		verify: "Verification",
		completeInfo: "Complete Your Information",
		completeInfoDesc: "Fill in your personal details to complete verification.",
		firstName: "First Name",
		paternalSurname: "Paternal Surname",
		maternalSurname: "Maternal Surname",
		contactNumber: "Contact Number",
		phoneUsed: "This phone number is already in use.",
		contactEmail: "Contact Email",
		invalidEmail: "Invalid email address.",
		detailedAddress: "Detailed Address",
		city: "City",
		street: "Street",
		neighborhood: "Neighborhood",
		houseNumber: "House Number",
		postalCode: "Postal Code",
		save: "Save",
		male: "Male",
		female: "Female"
	},

	withdrawPassword: {
		changeTitle: "Change Withdrawal Password",
		setTitle: "Set Withdrawal Password",
		changeDesc: "Enter your old password and set a new withdrawal password.",
		setDesc: "Set a withdrawal password to protect your funds.",
		oldPlaceholder: "Old Withdrawal Password",
		newPlaceholder: "New Withdrawal Password",
		confirmPlaceholder: "Confirm Withdrawal Password"
	},

	contactBirthday: {
		title: "Contact Birthday",
		desc: "Bind your birthday to improve your account security.",
		label: "Contact Birthday",
		invalid: "Invalid birthday."
	},

	changePassword: {
		title: "Change Password",
		expiredDesc: "Your password has expired. Please set a new password to continue.",
		verifyOldDesc: "Enter your old password and set a new one.",
		passwordPlaceholder: "Old Password",
		newPlaceholder: "New Password",
		confirmPlaceholder: "Confirm New Password",
		lengthError: "Password must be 6 to 30 characters.",
		sameAsOld: "The new password cannot be the same as the old one.",
		confirmRequired: "Please confirm your new password.",
		notMatch: "The passwords do not match.",
		success: "Password changed successfully",
		failed: "Failed to change password"
	},


	settingsNav: {
		title: "Setting",
		accountInfo: "Account Info",
		security: "Security"
	},

	verificationBirthday: {
		title: "Birthday",
		securityTip: "Birthday for account security. Only you can bind it.",
		clickSelectBirthday: "Click to select birthday",
		invalidBirthday: "Invalid birthday",
		submitting: "Submitting...",
		confirm: "Confirm",
		cancel: "Cancel",
		selectBirthday: "Select Birthday",
		birthdayRequired: "Birthday is required",
		updateBirthdayFail: "Failed to update birthday",
		success: "Successfully updated",
		invalidMonth: "Invalid month (01-12)",
		invalidYear: "Invalid year",
		invalidDay: "Invalid day for the selected month",
	}

};